import CustomSelect from "./CustomSelect";

export default {
    components: {
        selectdropdown: CustomSelect
    }
}
